import { createSlice } from '@reduxjs/toolkit';
import { AssociationAiState } from 'types/associationAi';

const initialState: AssociationAiState = {
  isLoading: false,
  error: { statusCode: 0, message: '' },
  associationFiles: []
};

export const associationAiSlice = createSlice({
  name: 'associationAi',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ASSOCIATION FILE SUCCESS
    getAssociationFilesSuccess(state, action) {
      state.isLoading = false;
      state.associationFiles = action.payload;
    }
  }
});

// Reducer
export default associationAiSlice.reducer;
